import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "ui/components/dialog";

import TimesheetUnlockForm from "@/modules/timesheet/logs/components/unlock/form";

export default function UnlockTimesheetDialog({ date, open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Are you sure you want to unlock this day?</DialogTitle>
          <DialogDescription>
            It's recommended to log your timesheet daily and within the
            deadline. You can request to unlock this timesheet, but it’ll be
            tracked and may be considered during performance reviews.
          </DialogDescription>
        </DialogHeader>
        <TimesheetUnlockForm date={date} onOpenChange={onOpenChange} />
      </DialogContent>
    </Dialog>
  );
}
